<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- ประเภทการลา -->
              <v-select
                v-model="adjustRequest"
                :items="adjustType"
                dense
                outlined
                hide-details
                label="ประเภทปรับปรุงเวลา"
                  clearable
              clear-icon="mdi-close-circle"
                class="ma-2"
              ></v-select>
              <!-- วัน -->
              <!-- <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="วัน"
                class="ma-2"
              ></v-select> -->
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
                clearable
              clear-icon="mdi-close-circle"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
             <v-btn
                class="mt-2"
                elevation="2"
                color="info"
                text
                @click="getData()"
              >
                <v-icon left>mdi-calendar-search</v-icon>
                ค้นหา
              </v-btn>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="exportLeave()"
            >
              Download
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="getData()"
            >
              reload
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="searchAll"
              dense
              outlined
              append-icon="mdi-magnify"
              label="ค้นหา รายชื่อ"
            ></v-text-field>
          </v-col>
        </v-row>
          <!-- data table -->

        <v-col cols="12">
          <v-alert dense type="info" icon="mdi-account-switch">
            รายการ <strong>ขอ ปรับปรุงเวลา</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columnsItem"
                :items="dataItem"
                :search="searchAll"
                :items-per-page="10"
              >
              <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date_1(item.CREATE_DATE) }}
                </template>
              <template v-slot:[`item.leaveEmergency`]="{ item }">
                  <v-btn
            color="warning"
            fab
            small
            dark
              v-if="item.leaveEmergency ==='True'"
          >
            <v-icon>mdi-alert</v-icon>
          </v-btn>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), dialog=true"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>

        <v-col cols="12">
          <v-alert dense type="success" icon="mdi-account-switch">
            รายการ <strong>อนุมัติปรับปรุงเวลา</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columnsItem"
                :items="dataItemApprove"
                :search="searchAll"
                :items-per-page="10"
              >
              <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date_1(item.CREATE_DATE) }}
                </template>
              <template v-slot:[`item.leaveEmergency`]="{ item }">
                  <v-btn
            color="warning"
            fab
            small
            dark
              v-if="item.leaveEmergency ==='True'"
          >
            <v-icon>mdi-alert</v-icon>
          </v-btn>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), dialog=true"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>

        <v-col cols="12">
          <v-alert dense type="error" icon="mdi-account-switch">
            รายการ <strong>ไม่อนุมัติปรับปรุงเวลา</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columnsItem"
                :items="dataItemUnApprove"
                :search="searchAll"
                :items-per-page="10"
              >
              <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date_1(item.CREATE_DATE) }}
                </template>
              <template v-slot:[`item.leaveEmergency`]="{ item }">
                    <v-btn
                  color="warning"
                  fab
                  small
                  dark
                  v-if="item.leaveEmergency ==='True'"
                >
                  <v-icon>mdi-alert</v-icon>
                </v-btn>
              </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), dialog=true"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>

        <!-- end data table -->

        <!-- รายละเอียด -->
        <v-dialog v-model="dialog" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ dateItemInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ dateItemInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ dateItemInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ dateItemInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ dateItemInfo.masCompanyName }}</td>
                          </tr>
                          <tr>
                            <td>หัวหน้า</td>
                            <td>{{ dateItemInfo.empFull_NameTH_approve }}</td>
                          </tr>
                          <!-- <tr>
                            <td>กะพนักงานส่งคำร้อง</td>
                            <td>
                              <v-chip class="ma-2" color="yellow" label>
                                ({{ dateItemInfo.shiftTransferOldShiftCode }})
                                {{ dateItemInfo.OldDate }}
                              </v-chip>
                            </td>
                          </tr> -->
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*ขอปรับปรุงเวลา</div>
                      <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr style="background-color: #1b437c">
                          <th class="text-left">รายการ</th>
                          <th class="text-left">รายละเอียด</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>วันที่</td>
                          <td>{{ dateItemInfo.adjust_date }}</td>
                        </tr>
                        <tr>
                          <td>กะ</td>
                          <td>{{ dateItemInfo.shiftCode }} {{ dateItemInfo.shift_check_in }} - {{ dateItemInfo.shift_check_out }} </td>
                        </tr>
                        <tr>
                          <td>เวลาเข้างาน</td>
                          <td>{{ dateItemInfo.checkInStartStamp }}</td>
                        </tr>
                        <tr>
                          <td>สถานะเข้างาน</td>
                          <td>{{ dateItemInfo.lateStatus }}  ({{dateItemInfo.lateTime}})</td>
                        </tr>
                        <tr>
                          <td>เวลาเลิกงาน</td>
                          <td v-if="!!dateItemInfo.checkInEndStamp">{{ dateItemInfo.checkInEndStamp }}</td>
                          <td v-else>ไม่พบข้อมูล</td>
                        </tr>
                        <tr>
                          <td>ขอปรับปรุงประเภท</td>
                          <td v-if="dateItemInfo.adjustRequest ==='IN'"> <v-icon left> mdi-account-arrow-left-outline</v-icon> NO IN</td>
                          <td v-if="dateItemInfo.adjustRequest ==='OUT'"><v-icon left> mdi-account-arrow-right-outline</v-icon> NO OUT</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialog = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
              <v-btn
                v-if="dateItemInfo.status === 'draft'"
                elevation="2"
                x-large
                color="success"
                text
                @click="dataReady = false, approve(dateItemInfo, 'approve')"
              >
                <v-icon left> mdi-check-circle-outline</v-icon>
                อนุมัติ
              </v-btn>
              <v-btn
               v-if="dateItemInfo.status === 'draft'"
                elevation="2"
                x-large
                color="red"
                text
                @click="dataReady = false,approve(dateItemInfo, 'unapprove')"
              >
                <v-icon left> mdi-cancel</v-icon>
                ไม่อนุมัติ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import { gmapApi } from 'vue2-google-maps'
import dayName from '../../../assets/master/Date/day.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
import moment from 'moment'
import { mdiFormatLineStyle } from '@mdi/js'
// import LeaveRequestVue from './LeaveRequest.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    gmapApi
  },
  data () {
    return {
      path: '/adjust_request/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'Adjust หัวหน้า',
          disabled: false,
          href: '/HRM/CheckINOUT/AdjustRequest'
        }
      ],
      session: this.$session.getAll(),
      dateMax: moment().endOf('year').format('YYYY-MM-DD'),
      dateMin: moment().subtract(2, 'd').format('YYYY-MM-DD'),
      dateNow: moment().format('YYYY-MM-DD'),
      menu: false,
      modal: false,
      menu1: false,
      loading: false,
      loading2: false,
      dataReady: true,
      dialog: false,
      dialogAdd: false,
      dialogDetail: false,
      valid_add: true,
      columnsItem: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ประเภท', value: 'adjustRequest' },
        { text: 'วันที่', value: 'adjust_date' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'หัวหน้า', value: 'empFull_NameTH_approve' },
        { text: 'หมายเหตุ', value: 'adjustRemark' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        {
          text: 'ตรวจสอบ',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ],
      profile: '',
      dataItem: [],
      dataItemApprove: [],
      dataItemUnApprove: [],
      dateItemInfo: [],
      dataItemQuota: [],
      leaveTypeItem: [],
      dataItemEmployee: [],
      dataItemHeader: [],
      leaveTypeCode: '',
      adjustType: ['IN', 'OUT'],
      adjustRequest: '',
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      year: '',
      month: '',
      day: '',
      disableYear: true,
      disableMonth: true,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      profileHeader: [],
      itemsLeave: [],
      itemsLeaveQuota: [],
      itemsLeaveSelect: [],
      itemsLeaveTypeQuota: [],
      itemsLeaveTypeSelectByProfile: [],
      itemsQuota: [],
      files: null,
      files2: null,
      imageHeadHRM: '',
      imageUrlBack: '',
      imageUrlleve: '',
      select: '',
      sumLeave: 0,
      nameRules: [(v) => !!v || 'Input is required'],
      numberRules: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) ||
          'กรุณา กรอกเป็นตัวเลข 0-9',
        (v) => (v && v.length === 10) || 'Max 10 characters'
      ],
      imageRules: [
        (value) =>
          !value || value.size < 2000000 || 'size should be less than 2 MB!'
      ]
    }
  },
  async mounted () {
    // console.log(moment().format('YYYY'))
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()
    await this.getDataDepartment()
    await this.getData()
    // await this.getDataCompany()
    // await this.getDataBranch()
    // await this.getDataLeaveType()
    // await this.getEmployee()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break

        default:
          break
      }
    },
    async getData () {
      await this.getDataRequest('draft')
      await this.getDataRequest('approve')
      await this.getDataRequest('unapprove')
    },
    async getDataRequest (status) {
      this.adjustRequest = (this.adjustRequest) ? this.adjustRequest : null
      this.month = (this.month) ? this.month : null
      var adjustRequest = (this.adjustRequest !== null) ? '&adjustRequest=' + this.adjustRequest : ''
      var monthSearch = (this.month !== null) ? '&adjust_month=' + this.getMonthThToINT(this.month) : ''
      var url = '/adjust_request/get?empCodeApprove=' + this.$session.getAll().data.empCode + '&status=' + status + '&adjust_year=' + this.year + adjustRequest + monthSearch

      var dataItem = await axios
        .get(
          this.DNS_IP + url,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )

      switch (status) {
        case 'draft': this.dataItem = (dataItem.data) ? dataItem.data : []; break
        case 'approve': this.dataItemApprove = (dataItem.data) ? dataItem.data : []; break
        case 'unapprove': this.dataItemUnApprove = (dataItem.data) ? dataItem.data : []; break
      }
    },
    async getDataById (item) {
      console.log('Get By ID', item)
      this.dateItemInfo = item
    },
    async approve (item, status) {
      this.$swal({
        title: 'ท่านต้องการ ' + status + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let ds = {
            status: status,
            LAST_USER: this.$session.getAll().data.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/adjust_request/edit/" + item.adjustID,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              if (status === 'approve') {
                await this.updateCheckINOUT(item, status)
              }
              let form = {
                adjust_date: item.adjust_date,
                adjustRequest: item.adjustRequest,
                status: status
              }
              await this.sendLineRequetAdustLiffSendMessage(form, item.empFull_NameTH, item.userLineuserId)
              await this.getData()
              this.dialog = mdiFormatLineStyle
              this.dataReady = true
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log(error)
            })
        })
        .catch((error) => {
          console.log('error approve : ', error)
          this.dataReady = true
        })
    },
    async updateCheckINOUT (item, status) {
      let ds = {}
      ds.adjustStatus = item.adjustRequest
      if (item.adjustRequest === 'OUT') {
        ds.checkInEndStamp = item.shift_check_out
        ds.earlyTime = '00:00'
        ds.earlyStatus = 'ปกติ'
        ds.endDate = item.shift_check_out
      } else if (item.adjustRequest === 'IN') {
        ds.checkInStartStamp = item.shift_check_in
        ds.lateStatus = 'ปกติ'
        ds.lateTime = '00:00'
      }

      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/ch_checkin/adjust_edit/" + item.checkInId,
          ds,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
    },
    async sendLineRequetAdustLiffSendMessage (data, empName, userLineId) {
      var statusName = ''
      var color = ''
      var imageUrl = ''
      switch (data.status) {
        case 'draft':
          statusName = 'รออนุมัติ'
          color = 'FFC107'
          imageUrl = 'https://firebasestorage.googleapis.com/v0/b/vgroup-hrm.appspot.com/o/img%2Fadjust%2FAdjust_Draft.png?alt=media&token=91b45ce6-271d-48e0-a3a6-a87f4c2fb22b'
          break
        case 'approve':
          statusName = 'อนุมัติ'
          color = '0d6e00'
          imageUrl = 'https://firebasestorage.googleapis.com/v0/b/vgroup-hrm.appspot.com/o/img%2Fadjust%2FAdjust_Approve.png?alt=media&token=13d450a9-f731-41a6-bb99-9eb7c6d5bab3'

          break
        case 'unapprove':
          statusName = 'ไม่อนุมัติ'
          color = '800311'
          imageUrl = 'https://firebasestorage.googleapis.com/v0/b/vgroup-hrm.appspot.com/o/img%2Fadjust%2FAdjust_Unapprove.png?alt=media&token=91999712-d66b-4b9d-87e3-d96044b01bc0'

          break
        default:
          break
      }

      // Draft
      var configMessgae = {
        empFull_NameTH: empName,
        statusReuest: statusName,
        adjustRequest: data.adjustRequest,
        adjust_date: data.adjust_date,
        imageAdjustUrl: imageUrl
      }

      const payload = []
      payload.push(
        {
          type: 'flex',
          altText:
            configMessgae.empFull_NameTH + '[ขออนุมัติ No Check ' + configMessgae.adjustRequest + ']',
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: configMessgae.imageAdjustUrl,
                  size: '60%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px',
              offsetTop: 'md'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: 'คำร้องขอ  No Check ' + configMessgae.adjustRequest,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: configMessgae.statusReuest,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color,
                      weight: 'regular',
                      style: 'normal',
                      decoration: 'none'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: configMessgae.empFull_NameTH,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'วันที่ขอแก้ไข ' + configMessgae.adjust_date,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'วันที่ทำรายการ ' + moment().format('YYYY-MM-DD HH:mm:ss'),
                      wrap: true,
                      align: 'center'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบประวัติ',
                    uri: 'line://app/1654154168-JML0KbN5?page=AdjustCheckInCheckOut'
                  },
                  style: 'secondary',
                  margin: '10px',
                  adjustMode: 'shrink-to-fit'
                }
              ]
            }
          }
        }
      )
      await this.sendPushMessage(payload, userLineId)
    },
    async sendPushMessage (payload, lineid) {
      const msgPayload = {
        to: lineid,
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      await axios.post(
        // eslint-disable-next-line quotes
        this.DNS_IP + "/line/push_message",
        dt,
        {
          headers: {
            'Application-Key': localStorage.getItem('ApplicationKey')
          }
        }
      )
    },
    async clear () {
      console.log('clear')
      this.Company = ''
      this.Branch = ''
      this.Department = ''
      this.adjustRequest = ''
      await this.getData()
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          this.DNS_IP +
          '/master_department/get?masBranchName=' +
            this.$session.getAll().data.masBranchName,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async exportLeave () {
      var dataItme = []
      var dataApprove = []
      var dataUnapprove = []
      this.dataItem.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ประเภท': element.adjustRequest,
          'สถานะ': element.status,
          'วัน': element.adjust_day,
          'เดือน': element.adjust_month,
          'ปี': element.adjust_year,
          'วัน/เดือน/ปี': element.adjust_date,
          'หัวหน้า': element.empFull_NameTH_approve,
          'รายละเอียด': element.adjustRemark,
          'รายละเอียดหัวหน้า': element.adjustRemarkHeader,
          'วันที่สร้างข้อมูล': element.CREATE_DATE,
          'วันที่แก้ไขข้อมูล': element.LAST_DATE,
          'ผู้แก้ไข': element.LAST_USER
        }
        dataItme.push(s)
      })
      this.dataItemApprove.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ประเภท': element.adjustRequest,
          'สถานะ': element.status,
          'วัน': element.adjust_day,
          'เดือน': element.adjust_month,
          'ปี': element.adjust_year,
          'วัน/เดือน/ปี': element.adjust_date,
          'หัวหน้า': element.empFull_NameTH_approve,
          'รายละเอียด': element.adjustRemark,
          'รายละเอียดหัวหน้า': element.adjustRemarkHeader,
          'วันที่สร้างข้อมูล': element.CREATE_DATE,
          'วันที่แก้ไขข้อมูล': element.LAST_DATE,
          'ผู้แก้ไข': element.LAST_USER
        }
        dataApprove.push(s)
      })
      this.dataItemUnApprove.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ประเภท': element.adjustRequest,
          'สถานะ': element.status,
          'วัน': element.adjust_day,
          'เดือน': element.adjust_month,
          'ปี': element.adjust_year,
          'วัน/เดือน/ปี': element.adjust_date,
          'หัวหน้า': element.empFull_NameTH_approve,
          'รายละเอียด': element.adjustRemark,
          'รายละเอียดหัวหน้า': element.adjustRemarkHeader,
          'วันที่สร้างข้อมูล': element.CREATE_DATE,
          'วันที่แก้ไขข้อมูล': element.LAST_DATE,
          'ผู้แก้ไข': element.LAST_USER
        }
        dataUnapprove.push(s)
      })
      var data = XLSX.utils.json_to_sheet(dataItme)
      var unapprove = XLSX.utils.json_to_sheet(dataUnapprove)
      var approve = XLSX.utils.json_to_sheet(dataApprove)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, data, 'รายการคำขอ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, approve, 'รายการอนุมัติ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, unapprove, 'รายการไม่อนุมัติ') // sheetAName is name of Worksheet
      this.month = this.getMonthTh()
      let date = new Date()
      this.year = moment().format('YYYY')
      this.day = date.getDate()
      XLSX.writeFile(
        wb,
        'adjust(' + this.month + ' ' + this.year + ').xls'
      ) // name of the file is 'book.xlsx'
    }
  }
}
</script>
<style scope>
:root {
  --table-head-text: #ffffff;
  --table-body-row-even: #b1c9ea;
  --table-body-row-odd: #ffffff;
}
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/CheckINOUT/AdjustRequestHeader.vue